export const baseUrl = "https://api.themoviedb.org/3";
export const API_KEY = "98b508ac2091065048410744e9e32538";
export const imageUrl = "https://image.tmdb.org/t/p/original";
